import React from 'react';
import Icon from '../../../components/AppIcon';

const RegistrationProgress = ({ currentStep, totalSteps }) => {
  const steps = [
    { number: 1, label: 'Personal Info', icon: 'User', shortLabel: 'Info' },
    { number: 2, label: 'Medical Credentials', icon: 'FileText', shortLabel: 'Credentials' },
    { number: 3, label: 'Documentation', icon: 'Upload', shortLabel: 'Docs' },
    { number: 4, label: 'Security', icon: 'Shield', shortLabel: 'Security' }
  ];

  return (
    <div className="w-full bg-card border border-border rounded-lg p-3 sm:p-6 mb-4 sm:mb-6">
      {/* Mobile: Vertical progress with current step highlighted */}
      <div className="block sm:hidden space-y-3">
        {steps?.map((step) => (
          <div
            key={step?.number}
            className={`flex items-center gap-3 p-3 rounded-lg transition-all ${
              currentStep === step?.number
                ? 'bg-primary/10 border border-primary/20'
                : currentStep > step?.number
                ? 'bg-success/5' :'bg-muted/30'
            }`}
          >
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-clinical ${
                currentStep >= step?.number
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}
            >
              {currentStep > step?.number ? (
                <Icon name="Check" size={16} />
              ) : (
                <span className="text-sm font-semibold">{step?.number}</span>
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p
                className={`text-sm font-medium truncate ${
                  currentStep >= step?.number ? 'text-foreground' : 'text-muted-foreground'
                }`}
              >
                {step?.label}
              </p>
              {currentStep === step?.number && (
                <p className="text-xs text-primary font-medium mt-0.5">Current Step</p>
              )}
            </div>
            {currentStep > step?.number && (
              <Icon name="CheckCircle2" size={18} color="var(--color-success)" />
            )}
          </div>
        ))}
      </div>
      {/* Desktop: Horizontal progress bar */}
      <div className="hidden sm:flex items-center justify-between">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.number}>
            <div className="flex flex-col items-center gap-2">
              <div
                className={`w-10 h-10 lg:w-12 lg:h-12 rounded-full flex items-center justify-center transition-clinical ${
                  currentStep >= step?.number
                    ? 'bg-primary text-primary-foreground'
                    : currentStep === step?.number - 1
                    ? 'bg-primary/20 text-primary' :'bg-muted text-muted-foreground'
                }`}
              >
                {currentStep > step?.number ? (
                  <Icon name="Check" size={20} />
                ) : (
                  <Icon name={step?.icon} size={20} />
                )}
              </div>
              <span
                className={`text-xs font-medium text-center max-w-[80px] ${
                  currentStep >= step?.number ? 'text-foreground' : 'text-muted-foreground'
                }`}
              >
                <span className="hidden lg:inline">{step?.label}</span>
                <span className="lg:hidden">{step?.shortLabel}</span>
              </span>
            </div>
            {index < steps?.length - 1 && (
              <div className="flex-1 h-0.5 mx-2 mb-6">
                <div
                  className={`h-full transition-clinical ${
                    currentStep > step?.number ? 'bg-primary' : 'bg-border'
                  }`}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default RegistrationProgress;